import React, { useState } from 'react'
import cx from 'classnames'
import { l } from '@manychat/manyui'

import cm from './TikTokCommentTitleImg.module.css'

interface TikTokCommentTitleImgProps {
  url: string
}

export function TikTokCommentTitleImg({ url }: TikTokCommentTitleImgProps) {
  const [isLoaded, setIsLoaded] = useState(false)

  const handleLoad = () => {
    setIsLoaded(true)
  }

  return (
    <div className={cm.imageContainer}>
      {url && (
        <img
          alt={l.translate('Specific TikTok preview')}
          title={l.translate('Specific TikTok preview')}
          src={url}
          className={cx('m-a-0', { [cm.hidden]: !isLoaded })}
          onLoad={handleLoad}
          height={16}
          width={16}
        />
      )}
    </div>
  )
}
